import TextOverflowTooltip from '@atom/components/common/tooltip/TextOverflowTooltip';
import { DatePicker, DateTimePicker } from '@atom/mui';
import colors from '@atom/styles/colors';
import fonts from '@atom/styles/fonts';
import { DataType } from '@atom/types/dataType';
import { TaskField } from '@atom/types/task';
import { WorkOrderField } from '@atom/types/work';

const styles = {
  dateSeparator: {
    paddingBottom: '0.5rem',
  },
};

interface Props {
  field: WorkOrderField | TaskField;
  startDateValue: any;
  endDateValue: any;
  onStartDateChange: (id: string, value: any) => void;
  onEndDateChange: (id: string, value: any) => void;
}

const WorkOrdersFiltersDatePicker = ({
  field,
  startDateValue,
  endDateValue,
  onStartDateChange,
  onEndDateChange,
}: Props) => {
  return field.dataType === DataType.DATE ? (
    <div>
      <TextOverflowTooltip
        text={field.title}
        color={colors.neutral.dim}
        fontSize={fonts.sm}
      />
      <DatePicker
        value={startDateValue}
        onChange={date => onStartDateChange(field.id, date)}
      />
      <span style={styles.dateSeparator}>to</span>
      <DatePicker
        value={endDateValue}
        onChange={date => onEndDateChange(field.id, date)}
      />
    </div>
  ) : (
    <div>
      <TextOverflowTooltip
        text={field.title}
        color={colors.neutral.dim}
        fontSize={fonts.sm}
      />
      <DateTimePicker
        value={startDateValue}
        onChange={date => onStartDateChange(field.id, date)}
      />
      <span style={styles.dateSeparator}>to</span>
      <DateTimePicker
        value={endDateValue}
        onChange={date => onEndDateChange(field.id, date)}
      />
    </div>
  );
};

export default WorkOrdersFiltersDatePicker;
